import React from 'react';
import './DeleteButton.css';

const DeleteButton = ({ onClick }) => (
  <button type="button" className="delete-button" onClick={onClick}>
    ×
  </button>
);

export default DeleteButton;